export const USER_GROUPS = {
    ORG_REPORT_ADMIN: 'OrgReportAdmin',
    REPORT_ADMIN: 'ReportAdmin',
    AUDUBON_ADMIN: 'AudubonAdmin',
    KIOSK_USER: 'KioskUser',
    KIOSK_CONTRACTOR: 'KioskContractor',
    ALDO_ADMIN: 'AldoAdmin'
}